"use client";

import { useActionState } from "react";
import Link from "next/link";
import { requestResetAction, type ResetState } from "../actions";
import { t } from "@/lib/i18n";
import { useLang } from "../../LangProvider";
import FloatingControls from "../../FloatingControls";

const initial: ResetState = {};

export default function ForgotPage() {
  const lang = useLang();
  const [state, formAction, pending] = useActionState(requestResetAction, initial);

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <FloatingControls />
      <div className="w-full max-w-sm rounded-2xl border border-[var(--p-card-border)] bg-[var(--p-card)] p-8 shadow-xl backdrop-blur">
        <h1 className="mb-1 text-2xl font-bold text-[var(--p-heading)]">
          {t(lang, "forgot.title")}
        </h1>
        <p className="mb-6 text-sm text-[var(--p-muted)]">
          {t(lang, "forgot.subtitle")}
        </p>

        {state.ok ? (
          <div className="rounded-xl bg-[var(--p-soft)] p-5 text-center text-sm text-[var(--p-muted)]">
            {t(lang, "forgot.sent")}
          </div>
        ) : (
          <form action={formAction}>
            <input
              type="email"
              name="email"
              required
              placeholder={t(lang, "forgot.email")}
              className="mb-4 w-full rounded-lg border border-[var(--p-input-border)] bg-[var(--p-input-bg)] px-3 py-2 text-sm text-[var(--p-input-text)] placeholder:text-[var(--p-input-ph)] outline-none focus:border-[var(--p-heading)]"
            />
            {state.error && (
              <p className="mb-4 text-sm text-red-500">{state.error}</p>
            )}
            <button
              type="submit"
              disabled={pending}
              className="w-full rounded-full bg-[#4B3FA0] py-3 font-medium text-white transition hover:bg-[#3d3384] disabled:opacity-60"
            >
              {pending ? t(lang, "forgot.submitting") : t(lang, "forgot.submit")}
            </button>
          </form>
        )}

        <p className="mt-5 text-center text-sm text-[var(--p-muted)]">
          <Link href="/login" className="text-[var(--p-heading)] underline">
            {t(lang, "forgot.back")}
          </Link>
        </p>
      </div>
    </main>
  );
}
